import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationen from './locales/en.json';

import translationzhHK from './locales/zh-HK.json';

import translationms from './locales/ms.json';

import translationzhCN from './locales/zh-CN.json';

import translationzhTW from './locales/zh-TW.json';

import translationid from './locales/id.json';



i18n

.use(Backend)

.use(LanguageDetector)

.use(initReactI18next)

.init({
lng: 'id',
fallbackLng: 'en',
debug: false,

interpolation: {
escapeValue: false,
},
resources: {

"en": {
translation: translationen
},

"zh-HK": {
translation: translationzhHK
},

"ms": {
translation: translationms
},

"zh-CN": {
translation: translationzhCN
},

"zh-TW": {
translation: translationzhTW
},

"id": {
translation: translationid
},



}
});


export default i18n;